<template>
  <img :src="`/icons/${name}.svg`" :alt="alt?alt:name" v-bind="$attrs" class="w-4 m-2" />
</template>

<script setup lang="ts">
defineProps({
  name: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: false,
  },
})
</script>
